module.exports = __webpack_public_path__ + "static/img/company-default-logo.c21665f7.png";